var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterCestaPitanja(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6,.cls-8,.cls-9{fill:none;}.cls-1{stroke:#fa7268;}.cls-1,.cls-6,.cls-9{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-6,.cls-8,.cls-9{stroke-width:1.5px;}.cls-2{fill:#fff;}.cls-2,.cls-8{stroke:#231f20;stroke-linejoin:round;}.cls-2,.cls-6,.cls-8{stroke-linecap:round;}.cls-3{fill:#159497;}.cls-4{fill:#6e5dd8;}.cls-5{fill:#fa7268;}.cls-6{stroke:#000;}.cls-7{fill:#231f20;}.cls-9{stroke:#6e5dd8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 300,
    cy: 162.5,
    rx: 258.4,
    ry: 122.79,
    transform: "translate(-28.17 69.15) rotate(-12.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 169.66,
    cy: 98.58,
    r: 78.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.67,303.4c.59,0,4.5-14.86,4.82-15.84,11.92-36.55,26.11-72.73,60.78-93.3,19.26-11.43,41.78-16.76,64.18-17.25,16.81-.37,33.87,2,49.34,8.57C403,197.2,419.85,222.67,431,249.07c9.16,21.73,13.23,54.33,13.23,54.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 44.86,
    cy: 283.71,
    r: 8.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 470.91,
    y: 117.25,
    width: 16.69,
    height: 16.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "535.15 287.65 544.1 272.16 526.21 272.16 535.15 287.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 334.44,
    cy: 103,
    r: 67.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 117.25,
    r: 5.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.44,
    cy: 119.45,
    r: 5.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.57,141.07a12.73,12.73,0,0,0,18,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M334.44,35.68A67.33,67.33,0,0,0,267.11,103c0,1.2,0,2.38.1,3.55,20.94.56,42.17-7.45,57-22.34a93.54,93.54,0,0,0,48.34,30.27,92.89,92.89,0,0,0,27.75,2.63,67.34,67.34,0,0,0-65.84-81.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 401.77,
    cy: 46.55,
    r: 35.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 281.03,
    cy: 43.02,
    r: 35.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M401.21,280.44c-5.27-12.39-14.42-32.12-20.08-44.34l-33.9-73.26a2.67,2.67,0,0,0-4.85,0c-3.26,6.85-2,15.91,3.68,21.11l-37.91-20.55a3.18,3.18,0,0,0-4.35,4.24,59.71,59.71,0,0,0,20.78,22.84,18.11,18.11,0,0,0-10.19,18.85c.74,4.64,3.3,8.76,5.9,12.67,3.15,4.75,6.46,9.4,9.77,14l41.46,58.23C382.78,294.73,394.8,289.71,401.21,280.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.08,60.44a27.64,27.64,0,0,1,4.88,16q0,11.65-8.3,18.78t-21.11,9.61l-.87,13.1H156.92l-1.31-24.89q12.52-1,20.89-5.17t8.37-11a11.49,11.49,0,0,0-5-9.68q-5-3.72-13.18-3.72a34.9,34.9,0,0,0-22.85,8.45l-9.47-14.85a53.44,53.44,0,0,1,15.29-8.52,52.47,52.47,0,0,1,18.05-3.13,44.82,44.82,0,0,1,19,3.93A32,32,0,0,1,200.08,60.44Zm-20.89,77.88a13.39,13.39,0,0,1-26.78,0,12.72,12.72,0,0,1,3.93-9.31,13.45,13.45,0,0,1,18.92-.08A12.69,12.69,0,0,1,179.19,138.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M226.15,152.55A31.25,31.25,0,0,0,270.22,149"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M28.83,142c17.91-6.46,33.37-6.37,43.08,12.94,5.31,10.54,6.73,22.56,10.44,33.75,5.59,16.88,16.93,32.23,32.64,40.54s35.89,8.77,50.9-.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M475.23,281.54c-21.09-19.14-30.85-49.92-24.66-77.71,3.61-16.18,13.24-32,28.51-38.43,17.07-7.2,36.68-1.31,53.67,6.08,5.41,2.36,10.84,4.92,15.21,8.89s7.59,9.57,7.38,15.47c-.36,10.43-11.86,18-22.23,16.79s-19-9-24.24-18a55.9,55.9,0,0,1,31.84-81.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterCestaPitanja);
export default __webpack_public_path__ + "static/media/Footer-cesta_pitanja.d7202fc996c591aead67e6ec6da76853.svg";
export { ForwardRef as ReactComponent };